// extracted by mini-css-extract-plugin
export default {"term":"cli717rmi","termContent":"cd8qcwcnj"};